import { useEffect } from "react";
import { useLoading } from "./LoadingContext";

const useApiLoader = (isLoading) => {
  const { setIsLoading, setProgress } = useLoading();

  useEffect(() => {
    setIsLoading(isLoading);
    if (isLoading) {
      setProgress(0);
    }
  }, [isLoading, setIsLoading, setProgress]);

  useEffect(() => {
    if (!isLoading) {
      setProgress(100);
    }
  }, [isLoading, setProgress]);
};

export default useApiLoader;